export default class AnalysisIncome {
  constructor(field, amount) {
    this.field = field;
    this.amount = amount;
  }
}
